import { useEffect, useState } from "react";

export function useMobile() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    function windowResize() {
      if (window.matchMedia("(max-width: 1200px)").matches) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    }

    windowResize();

    window.addEventListener("resize", windowResize);

    return () => {
      window.removeEventListener("resize", windowResize);
    };
  }, []);

  return isMobile;
}
